import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1424bc9d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "BridgeProcessor" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["disabled"]
const _hoisted_4 = {
  key: 3,
  class: "BridgeProcessor-infoWrapper"
}
const _hoisted_5 = { class: "BridgeProcessor-infoLine" }
const _hoisted_6 = {
  key: 0,
  class: "BridgeProcessor-info-text"
}
const _hoisted_7 = { class: "BridgeProcessor-info-text-send" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = { class: "BridgeProcessor-info-text-send-buttons" }
const _hoisted_13 = ["href"]
const _hoisted_14 = {
  key: 1,
  class: "BridgeProcessor-info-text-scanQRCode"
}
const _hoisted_15 = {
  class: "BridgeProcessor-info-text-QRCode",
  ref: "qrcode"
}
const _hoisted_16 = {
  key: 1,
  class: "BridgeProcessor-info-text"
}
const _hoisted_17 = {
  key: 0,
  class: "BridgeProcessor-infoLine"
}
const _hoisted_18 = { class: "BridgeProcessor-info-text" }
const _hoisted_19 = { class: "BridgeProcessor-infoLine" }
const _hoisted_20 = { class: "BridgeProcessor-info-text" }
const _hoisted_21 = { class: "BridgeProcessor-infoLine" }
const _hoisted_22 = { class: "BridgeProcessor-info-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.state.step === 0 && (_ctx.isFromTon || _ctx.hasApprove || _ctx.token === 'ton'))
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: _normalizeClass(["BridgeProcessor-transfer", {
        showLoader:
          _ctx.isInitInProgress || _ctx.isBurningInProgress || _ctx.isLockingInProgress,
      }]),
          disabled: !_ctx.isInputsValid,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onTransferClick && _ctx.onTransferClick(...args)))
        }, _toDisplayString(_ctx.$t("transfer")), 11, _hoisted_2))
      : _createCommentVNode("", true),
    (_ctx.state.step === 0 && !_ctx.isFromTon && !_ctx.hasApprove && _ctx.token !== 'ton')
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          class: _normalizeClass(["BridgeProcessor-transfer", { showLoader: _ctx.isApprovingInProgress || _ctx.isGetAllowanceInProcess }]),
          disabled: !_ctx.isInputsValid || _ctx.isGetAllowanceError,
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onApproveClick && _ctx.onApproveClick(...args)))
        }, _toDisplayString(_ctx.isApprovingInProgress ? _ctx.$t('confirmInWallet', {provider: _ctx.ethereumProvider.title}) : _ctx.$t("approve")), 11, _hoisted_3))
      : _createCommentVNode("", true),
    (_ctx.isCancelButtonVisible)
      ? (_openBlock(), _createElementBlock("button", {
          key: 2,
          class: "BridgeProcessor-cancel",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onCancelClick && _ctx.onCancelClick(...args)))
        }, _toDisplayString(_ctx.$t("cancel")), 1))
      : _createCommentVNode("", true),
    (_ctx.state.step > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", {
              class: _normalizeClass(["BridgeProcessor-info-icon", {
            none: _ctx.state.step < 1,
            pending: _ctx.state.step === 1,
            done: _ctx.state.step > 1,
          }])
            }, null, 2),
            (!_ctx.getStepInfoText1.isOnlyText)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", null, [
                      _createTextVNode(_toDisplayString(_ctx.getStepInfoText1.send1) + " ", 1),
                      _createElementVNode("button", {
                        class: "BridgeProcessor-info-text-copy",
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onCopyClick && _ctx.onCopyClick(...args)))
                      }, _toDisplayString(_ctx.getStepInfoText1.amountReadable), 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.getStepInfoText1.send2), 1),
                      _hoisted_8,
                      _createElementVNode("button", {
                        class: "BridgeProcessor-info-text-copy",
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onCopyClick && _ctx.onCopyClick(...args)))
                      }, _toDisplayString(_ctx.getStepInfoText1.toAddress), 1),
                      _hoisted_9,
                      _createTextVNode(" " + _toDisplayString(_ctx.getStepInfoText1.withComment), 1),
                      _hoisted_10,
                      _createElementVNode("button", {
                        class: "BridgeProcessor-info-text-copy",
                        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onCopyClick && _ctx.onCopyClick(...args)))
                      }, _toDisplayString(_ctx.getStepInfoText1.comment), 1),
                      _hoisted_11
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("a", {
                        href: _ctx.getStepInfoText1.openWalletUrl,
                        class: "BridgeProcessor-info-text-openWallet",
                        target: "_blank"
                      }, _toDisplayString(_ctx.getStepInfoText1.openWalletLabel), 9, _hoisted_13),
                      (!_ctx.isQRCodeShown)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "BridgeProcessor-info-text-generateQRCode",
                            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.generateQRCode && _ctx.generateQRCode(...args)))
                          }, _toDisplayString(_ctx.getStepInfoText1.generateQRCode), 1))
                        : _createCommentVNode("", true),
                      (_ctx.isQRCodeShown)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.getStepInfoText1.scanQRCode), 1))
                        : _createCommentVNode("", true),
                      _withDirectives(_createElementVNode("div", _hoisted_15, null, 512), [
                        [_vShow, _ctx.isQRCodeShown]
                      ])
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_ctx.getStepInfoText1.text), 1))
          ]),
          (!_ctx.isFromTon)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createElementVNode("div", {
                  class: _normalizeClass(["BridgeProcessor-info-icon", {
            none: _ctx.state.step < 2,
            pending: _ctx.state.step === 2,
            done: _ctx.state.step > 2,
          }])
                }, null, 2),
                _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.getStepInfoText2), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", {
              class: _normalizeClass(["BridgeProcessor-info-icon", {
            none: _ctx.state.step < 3,
            pending: _ctx.state.step === 3,
            done: _ctx.state.step > 3,
          }])
            }, null, 2),
            _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.getStepInfoText3), 1)
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", {
              class: _normalizeClass(["BridgeProcessor-info-icon", {
            none: _ctx.state.step < 4,
            pending: _ctx.state.step === 4,
            done: _ctx.state.step > 4,
          }])
            }, null, 2),
            _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.getStepInfoText4), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isMintToncoinButtonVisible)
      ? (_openBlock(), _createElementBlock("button", {
          key: 4,
          class: _normalizeClass(["BridgeProcessor-getTonCoin", { showLoader: _ctx.isMintingInProgress }]),
          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.mint && _ctx.mint(...args)))
        }, _toDisplayString(_ctx.isMintingInProgress ? _ctx.$t('confirmInWallet', {provider: _ctx.ethereumProvider.title}) : _ctx.$t("getToncoin", {coin: _ctx.toCoin})), 3))
      : _createCommentVNode("", true),
    (_ctx.isDoneButtonVisible)
      ? (_openBlock(), _createElementBlock("button", {
          key: 5,
          class: "BridgeProcessor-done",
          onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onDoneClick && _ctx.onDoneClick(...args)))
        }, _toDisplayString(_ctx.$t("done")), 1))
      : _createCommentVNode("", true)
  ]))
}